// Licensed to Elasticsearch B.V under one or more agreements.
// Elasticsearch B.V licenses this file to you under the Apache 2.0 License.
// See the LICENSE file in the project root for more information
'use strict';
/* eslint camelcase: 0 */

/* eslint no-unused-vars: 0 */

var _objectWithoutProperties = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function buildIndicesFlush(opts) {
  // eslint-disable-next-line no-unused-vars
  var makeRequest = opts.makeRequest,
      ConfigurationError = opts.ConfigurationError,
      handleError = opts.handleError,
      snakeCaseKeys = opts.snakeCaseKeys;
  /**
   * Perform a [indices.flush](http://www.elastic.co/guide/en/elasticsearch/reference/master/indices-flush.html) request
   *
   * @param {list} index - A comma-separated list of index names; use `_all` or empty string for all indices
   * @param {boolean} force - Whether a flush should be forced even if it is not necessarily needed ie. if no changes will be committed to the index. This is useful if transaction log IDs should be incremented even if no uncommitted changes are present. (This setting can be considered as internal)
   * @param {boolean} wait_if_ongoing - If set to true the flush operation will block until the flush can be executed if another flush operation is already executing. The default is true. If set to false the flush will be skipped iff if another flush operation is already running.
   * @param {boolean} ignore_unavailable - Whether specified concrete indices should be ignored when unavailable (missing or closed)
   * @param {boolean} allow_no_indices - Whether to ignore if a wildcard indices expression resolves into no concrete indices. (This includes `_all` string or when no indices have been specified)
   * @param {enum} expand_wildcards - Whether to expand wildcard expression to concrete indices that are open, closed or both.
   */

  var acceptedQuerystring = ['force', 'wait_if_ongoing', 'ignore_unavailable', 'allow_no_indices', 'expand_wildcards', 'pretty', 'human', 'error_trace', 'source', 'filter_path'];
  var snakeCase = {
    waitIfOngoing: 'wait_if_ongoing',
    ignoreUnavailable: 'ignore_unavailable',
    allowNoIndices: 'allow_no_indices',
    expandWildcards: 'expand_wildcards',
    errorTrace: 'error_trace',
    filterPath: 'filter_path'
  };
  return function indicesFlush(params, options, callback) {
    options = options || {};

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    if (typeof params === 'function' || params == null) {
      callback = params;
      params = {};
      options = {};
    } // check required parameters


    if (params.body != null) {
      var err = new ConfigurationError('This API does not require a body');
      return handleError(err, callback);
    } // validate headers object


    if (options.headers != null && typeof options.headers !== 'object') {
      var _err = new ConfigurationError("Headers should be an object, instead got: ".concat(typeof options.headers));

      return handleError(_err, callback);
    }

    var warnings = [];

    var _params = params,
        method = _params.method,
        body = _params.body,
        index = _params.index,
        querystring = _objectWithoutProperties(_params, ["method", "body", "index"]);

    querystring = snakeCaseKeys(acceptedQuerystring, snakeCase, querystring, warnings);

    if (method == null) {
      method = body == null ? 'GET' : 'POST';
    }

    var ignore = options.ignore;

    if (typeof ignore === 'number') {
      options.ignore = [ignore];
    }

    var path = '';

    if (index != null) {
      path = '/' + encodeURIComponent(index) + '/' + '_flush';
    } else {
      path = '/' + '_flush';
    } // build request object


    var request = {
      method: method,
      path: path,
      body: '',
      querystring: querystring
    };
    options.warnings = warnings.length === 0 ? null : warnings;
    return makeRequest(request, options, callback);
  };
}

module.exports = buildIndicesFlush;